import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { VehicleInsuranceStatusEnum } from '../enums/vehicle-insurance-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function vehicleInsuranceStatusToColor(
	status: VehicleInsuranceStatusEnum,
): string {
	switch (status) {
		case VehicleInsuranceStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case VehicleInsuranceStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case VehicleInsuranceStatusEnum.EXPIRED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
